import React from 'react'
import {BlockProps} from '../atoms/blockList'
import {RichTextBlockExampleValue} from './types'
import {TipTapBlock, emptyTipTapValue} from '@dudagroup/editor'
import {Col, Row, SelectPicker, Form} from 'rsuite'
import {withTipTapLanguage} from '../utility'
import {ContentModelSchemaFieldTipTap} from '@dudagroup/api'
import {useTranslation} from 'react-i18next'

export type RichTextBlockProps = BlockProps<RichTextBlockExampleValue>

/**
 * Edits the `tiptap` field of a rich-text block. The Slate `text` field beside
 * it is retired (see `retiredSlate()` in the API models) and no longer shown.
 */
export function RichTextBlockExampleBlock({
  value,
  onChange,
  model,
  autofocus,
  disabled,
  languageLaneL,
  languageLaneR,
  langUi,
  configs,
}: RichTextBlockProps) {
  const {tiptap, backgroundColor} = value
  const {t} = useTranslation()
  const data = (model.fields.backgroundColor as any).values.map((item: any) => {
    return {
      label: item.description,
      value: item.value,
    }
  })
  const config = (model.fields.tiptap as ContentModelSchemaFieldTipTap).config
  const languageContext = {
    langLane1: languageLaneL,
    langLane2: languageLaneR,
    langUi: langUi,
    languagesConfig: configs.apiConfig.languages,
  }

  return (
    <>
      <Row className="show-grid" style={{display: 'flex', alignItems: 'center', marginBottom: 24}}>
        <Col xs={14}>
          <Form.ControlLabel style={{marginRight: 10}}>
            {t('blockList.backgroundColor')}
          </Form.ControlLabel>
          <SelectPicker
            placement="autoVerticalStart"
            preventOverflow
            style={{width: '100%'}}
            data={data}
            value={backgroundColor}
            onChange={(val) => {
              onChange(val, ['backgroundColor'])
            }}
          />
        </Col>
      </Row>
      <Row className="show-grid" style={{display: 'flex', alignItems: 'top', marginBottom: 24}}>
        <Col xs={14} style={{padding: 0}}>
          <TipTapBlock
            languageContext={languageContext}
            config={config}
            value={tiptap?.[languageLaneL] || emptyTipTapValue()}
            onChange={(val) => {
              onChange(withTipTapLanguage(tiptap, languageLaneL, val), ['tiptap'])
            }}
            autofocus={autofocus}
            disabled={disabled}
          />
        </Col>
        {languageLaneR && (
          <>
            <Col xs={1} style={{textAlign: 'center', paddingTop: '5px'}}></Col>
            <Col xs={9}>
              <TipTapBlock
                languageContext={languageContext}
                config={config}
                value={tiptap?.[languageLaneR] || emptyTipTapValue()}
                onChange={() => {
                  // The right lane is a read-only reference.
                }}
                autofocus={false}
                displayOnly={true}
                disabled={true}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  )
}
